import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";

const EmployeeDetailForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues = {},
  errors = {},
}) => {
  const { user } = useContext(AuthContext);

  // console.log("loading: ", loading);

  const [formData, setFormData] = useState({
    employee_id: "",
    user_id: user?.id,
    full_name: "",
    date_of_birth: "",
    address: "",
    birth_place: "",
    nationality: "",
    religion: "",
    caste: "",
    sub_caste: "",
    blood_group: "",
    height: "",
    weight: "",
    marital_status: "",
    marriage_date: "",
    languages: "",
    is_handicapped: false,
    handicap_percentage: 0,
    handicap_nature: "",
    father_name: "",
    mother_name: "",
    spouse_name: "",
    gender: "",
    aadhar_no: "",
    pan_no: "",
    profile_image: null,

    // emergency fields
    contact_name: "",
    relationship: "",
    contact_phone: "",
    contact_email: "",

    ...initialValues
  });

  // console.log("formdata: ", formData)

//   // console.log("initial values:", initialValues);

  // 🛠️ Update formData if initialValues change (especially on edit)
  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      const normalizedUserId =
        typeof initialValues.user_id === "object"
          ? initialValues.user_id?.id
          : initialValues.user_id;
  
      setFormData((prev) => ({
        ...prev,
        ...initialValues,
        user_id: user?.id || normalizedUserId,
      }));
    }
  }, [initialValues, user]);
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let val = type === "checkbox" ? checked : value.trimStart();

    // Check for date_of_birth and apply validation
    if (name === "date_of_birth") {
      const selectedDate = new Date(val);
      const today = new Date();
      
      // Prevent future date selection
      if (selectedDate > today) {
        alert("Date of birth cannot be in the future.");
        return;
      }

      // Ensure the user is at least 18 years old
      let age = today.getFullYear() - selectedDate.getFullYear();
      const monthDifference = today.getMonth() - selectedDate.getMonth();
      
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < selectedDate.getDate())) {
        age--;  // ✅ Now allowed
      }
      

      if (age < 18) {
        alert("You must be at least 18 years old.");
        return;
      }
    }

    // Update form data
    setFormData((prev) => ({ ...prev, [name]: val }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0];
    
    // to preview
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setFormData((prev) => ({
        ...prev,
        [name]: file,
        [`${name}_preview`]: imageUrl,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Full name validation
    const fullNameRegex = /^[A-Za-z\s]+$/;
    if (!fullNameRegex.test(formData.full_name)) {
      // alert("Full name must contain only letters and spaces.");
      // return;
    }

    // Birth place validation
    const birthPlaceRegex = /^[A-Za-z\s]+$/;
    if (!birthPlaceRegex.test(formData.birth_place)) {
      // alert("Birthplace must contain only letters and spaces.");
      // return;
    }
    
    // nationality validation
    const nationalityRegex = /^[A-Za-z\s]+$/;
    if (!nationalityRegex.test(formData.nationality)) {
      // alert("Nationality must contain only letters and spaces.");
      // return;
    }

    // caste validation
    const casteRegex = /^[A-Za-z\s]+$/;
    if (!casteRegex.test(formData.caste)) {
      // alert("Caste must contain only letters and spaces.");
      // return;
    }

    // sub_caste validation
    const subcasteRegex = /^[A-Za-z\s]+$/;
    if (!subcasteRegex.test(formData.sub_caste)) {
      // alert("Sub-Caste must contain only letters and spaces.");
      // return;
    }

    // langugae validation
    const langugaeRegex = /^[A-Za-z\s]+$/;
    if (!langugaeRegex.test(formData.languages)) {
      // alert("Langugae must contain only letters and spaces.");
      // return;
    }

    // father_name validation
    const father_nameRegex = /^[A-Za-z\s]+$/;
    if (!father_nameRegex.test(formData.father_name)) {
      // alert("Father name must contain only letters and spaces.");
      // return;
    }

    // mother_name validation
    const mother_nameRegex = /^[A-Za-z\s]+$/;
    if (!mother_nameRegex.test(formData.mother_name)) {
      // alert("Mother name must contain only letters and spaces.");
      // return;
    }

    // spouse_name validation
    const spouse_nameRegex = /^[A-Za-z\s]+$/;
    if (!spouse_nameRegex.test(formData.spouse_name)) {
      // alert("Spouse name must contain only letters and spaces.");
      // return;
    }

    // contact_name validation
    // const contact_nameRegex = /^[A-Za-z\s]+$/;
    // if (!contact_nameRegex.test(formData.contact_name)) {
    //   // alert("Contact name must contain only letters and spaces.");
    //   // return;
    // }

    // contact_relationship validation
    // const relationshipRegex = /^[A-Za-z\s]+$/;
    // if (!relationshipRegex.test(formData.contact_name)) {
    //   // alert("Relationship contain only letters and spaces.");
    //   // return;
    // }

    // contact_phone validation
    // const contact_phoneRegex = /\D/g;
    // if (!contact_phoneRegex.test(formData.contact_phone)) {
    //   alert("Contact phone must 10 digit.");
    //   return;
    // }

    // contact_email validation
    // const contact_emailRegex = /\D/g;
    // if (!contact_emailRegex.test(formData.contact_email)) {
    //   // alert("Enter a valid email address.");
    //   // return;
    // }

    // handicap_nature validation
    const handicap_natureRegex = /^[A-Za-z\s]+$/;
    if (!handicap_natureRegex.test(formData.handicap_nature)) {
      // alert("Handicap nature must contain only letters and spaces.");
      // return;
    }
       
    // Aadhar number validation
    const aadharRegex = /^\d{12}$/;
    if (!aadharRegex.test(formData.aadhar_no)) {
      // alert("Aadhar number must be 12 digits.");
      // return;
    }

    // PAN number validation
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panRegex.test(formData.pan_no)) {
      // alert("PAN number is invalid. It should be in the format: XXXXX9999X.");
      // return;
    }
    
    // Create a new FormData object
    const formDataToSend = new FormData();
    
    // Correctly append each field to the FormData
    formDataToSend.append("employee_id", formData.employee_id);
    formDataToSend.append("user_id", formData.user_id);
    formDataToSend.append("full_name", formData.full_name);
    formDataToSend.append("date_of_birth", formData.date_of_birth);
    formDataToSend.append("address", formData.address);
    // formDataToSend.append("ssn", formData.ssn || "");
    formDataToSend.append("birth_place", formData.birth_place || "");
    formDataToSend.append("nationality", formData.nationality || "");
    formDataToSend.append("religion", formData.religion || "");
    formDataToSend.append("caste", formData.caste || "");
    formDataToSend.append("sub_caste", formData.sub_caste || "");
    formDataToSend.append("blood_group", formData.blood_group || "");
    formDataToSend.append("height", formData.height || "0");
    formDataToSend.append("weight", formData.weight || "0");
    formDataToSend.append("marital_status", formData.marital_status || "");
    formDataToSend.append("marriage_date", formData.marriage_date || "");
    formDataToSend.append("languages", formData.languages || "");
    
    // Handle boolean properly
    formDataToSend.append("is_handicapped", formData.is_handicapped ? "1" : "0");
    
    if (formData.is_handicapped) {
      formDataToSend.append("handicap_percentage", formData.handicap_percentage || "0");
      formDataToSend.append("handicap_nature", formData.handicap_nature || "");
    }
    
    formDataToSend.append("father_name", formData.father_name || "");
    formDataToSend.append("mother_name", formData.mother_name || "");
    formDataToSend.append("spouse_name", formData.spouse_name || "");
    
    formDataToSend.append("contact_name", formData.contact_name || "");
    formDataToSend.append("contact_phone", formData.contact_phone || "");
    formDataToSend.append("relationship", formData.relationship || "");
    formDataToSend.append("contact_email", formData.contact_email || "");

    formDataToSend.append("gender", formData.gender || "");
    formDataToSend.append("aadhar_no", formData.aadhar_no || "");
    formDataToSend.append("pan_no", (formData.pan_no || "").toUpperCase()); // sending PAN number in all upper case
    
    // Only append file if it's a File object
    if (formData.profile_image instanceof File) {
      formDataToSend.append("profile_image", formData.profile_image);
    }
    
    // Debug: Check FormData entries
    // console.log("FormData contents:");
    for (let pair of formDataToSend.entries()) {
      // console.log(pair[0] + ': ' + (pair[1] instanceof File ? `File: ${pair[1].name}` : pair[1]));
    }
    
    onSubmit(formDataToSend);
  };

  const renderInput = (label, name, type = "text", showAsterisk = false, is_required = false) => (
    <div>
      <label htmlFor={name} className="block dark:text-white text-sm font-medium text-gray-700">
        {label}
        {showAsterisk && <span className="text-red-500 ml-1">*</span>}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        value={formData[name] || ""}
        onChange={handleChange}
        required={is_required} 
        {...(type === "number" ? { min: 0 } : {})}
        className={`mt-1 block w-full dark:bg-gray-900 dark:text-white dark:border-gray-700 border rounded-md p-2 ${
          errors[name] ? "border-red-500" : "border-gray-300"
        }`}
      />
      {errors[name] && <p className="text-red-500 text-sm mt-1">{errors[name]}</p>}
    </div>
  );
  

  return (
    <form onSubmit={handleSubmit}>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 font-poppins">
        {/* default/non editable employee id field */}
        <div className="">
          <label htmlFor="employee_id" className="block text-sm dark:text-white font-medium text-gray-700">
            Employee ID <span className="text-red-500 ml-1">*</span>
          </label>
          <input
            type="text"
            id="employee_id"
            value={formData.employee_id}
            onChange={handleChange}
            disabled
            className="mt-1 block w-full dark:bg-gray-900 dark:text-white dark:border-gray-700 border border-gray-300 rounded-md p-2 bg-gray-200"
          />
        </div>

        {/* full name, date of birth, address, birth place, nationality, religion, caste, sub-caste fields */}
        {renderInput("Full Name", "full_name", "text", true, true)}
        {renderInput("Date of Birth", "date_of_birth", "date", true, true)}
        {renderInput("Address", "address",'text', true, true)}
        {renderInput("Birth Place", "birth_place")}
        {renderInput("Nationality", "nationality", "text")}
        {renderInput("Religion", "religion", "text")}
        {renderInput("Caste", "caste")}
        {renderInput("Sub Caste", "sub_caste")}

        {/* Blood Group Combobox */}
        <div className="mb-4">
          <label htmlFor="blood_group" className="block dark:text-white text-sm font-medium text-gray-700">
            Blood Group
          </label>
          <select
            id="blood_group"
            name="blood_group"
            value={formData.blood_group}
            onChange={handleChange}
            className="mt-1 block w-full p-3 dark:bg-gray-900 dark:text-white dark:border-gray-700 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">Select Blood Group</option>
            <option value="A+">A+</option>
            <option value="A-">A-</option>
            <option value="B+">B+</option>
            <option value="B-">B-</option>
            <option value="AB+">AB+</option>
            <option value="AB-">AB-</option>
            <option value="O+">O+</option>
            <option value="O-">O-</option>
          </select>
          {errors.blood_group && (
            <p className="text-red-500 text-sm mt-1">{errors.blood_group}</p>
          )}
        </div>

        {/* height field*/}
        <div className="">
          <label htmlFor="height" className="block text-sm dark:text-white font-medium text-gray-700">
            Height
          </label>
          <input
            type="number"
            step="0.2"
            id="height"
            name="height"
            value={formData.height}
            onChange={handleChange}
            min={0}
            max={10}
            className={`mt-1 block w-full dark:bg-gray-900 dark:text-white dark:border-gray-700 border rounded-md p-2 ${
              errors.height ? "border-red-500" : "border-gray-300"
            }`}
          />
        </div>

        {/* weight field */}
        <div className="">
          <label htmlFor="weight" className="block text-sm dark:text-white font-medium text-gray-700">
            Weight
          </label>
          <input
            type="number"
            step={0.2}
            id="weight"
            name="weight"
            value={formData.weight}
            onChange={handleChange}
            min={0}
            max={120}
            className={`mt-1 block w-full dark:bg-gray-900 dark:text-white dark:border-gray-700 border rounded-md p-2 ${
              errors.weight ? "border-red-500" : "border-gray-300"
            }`}
          />
        </div>

        {/* Marital Status Combobox */}
        <div className="mb-4">
          <label htmlFor="marital_status" className="block text-sm dark:text-white font-medium text-gray-700">
            Marital Status 
          </label>
          <select
            id="marital_status"
            name="marital_status"
            value={formData.marital_status}
            onChange={handleChange}
            className="mt-1 block w-full p-3 dark:bg-gray-900 dark:text-white dark:border-gray-700 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">Select Status</option>
            <option value="single">Single</option>
            <option value="married">Married</option>
            <option value="divorced">Divorced</option>
            <option value="widowed">Widowed</option>
          </select>
          {errors.marital_status && (
            <p className="text-red-500 text-sm mt-1">{errors.marital_status}</p>
          )}
        </div>

        {/* language field */}
        {renderInput("Languages Known", "languages")}

        {/* is handicapped field */}
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="is_handicapped"
            name="is_handicapped"
            checked={formData.is_handicapped}
            onChange={handleChange}
          />
          <label htmlFor="is_handicapped" className="text-sm dark:text-white font-medium text-gray-700">
            Is Handicapped?
          </label>
        </div>

        {/* handicap percentage and nature of handicap fields will only be visibled if is handicapped is checked */}
        {formData.is_handicapped && (
          <>
            {/* Handicap Percentage */}
            <div className="">
              <label
                htmlFor="handicap_percentage"
                className="block text-sm dark:text-white font-medium text-gray-700"
              >
                Handicap Percentage
              </label>
              <div className="relative">
                <input
                  type="number"
                  id="handicap_percentage"
                  name="handicap_percentage"
                  value={formData.handicap_percentage}
                  onChange={handleChange}
                  min={1}
                  max={100}
                  step="0.01" 
                  required
                  className={`mt-1 block w-full pr-10 dark:bg-gray-900 dark:text-white dark:border-gray-700 border rounded-md p-2 ${
                    errors.handicap_percentage
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                />
                <span className="absolute inset-y-0 right-3 flex items-center text-gray-500">
                  %
                </span>
              </div>
            </div>
            
            {/* nature of handicap field */}
            {renderInput("Nature of Handicap", "handicap_nature", true, true)}
          </>
        )}

        {renderInput("Father's Name", "father_name", 'text')}
        {renderInput("Mother's Name", "mother_name", 'text')}

        {/* spouse name field will only be visibled if marital status is married */}
        {formData.marital_status === "married" && (
          <div className="space-y-4">
            {renderInput("Marriage Date", "marriage_date", "date", true, true)}
            {renderInput("Spouse Name", "spouse_name", "text", true, true)}
          </div>
        )}
        
        {/* Gender Combobox */}
        <div className="mb-4">
          <label htmlFor="gender" className="block text-sm dark:text-white font-medium text-gray-700">
            Gender 
          </label>
          <select
            id="gender"
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            className="mt-1 block w-full p-3 dark:bg-gray-900 dark:text-white dark:border-gray-700 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
          {errors.gender && (
            <p className="text-red-500 text-sm mt-1">{errors.gender}</p>
          )}
        </div>

        {/* aadhar and pan number field */}
        {renderInput("Aadhar Number", "aadhar_no", "number")}
        {renderInput("PAN Number", "pan_no", "text")}

        {/* profile image field */}
        <div>
          <label htmlFor="profile_image" className="block text-sm dark:text-white font-medium text-gray-700">
            Profile Image
          </label>
          <input
            type="file"
            id="profile_image"
            name="profile_image"
            accept="image/*"
            onChange={handleFileChange}
            className={`mt-1 block w-full border dark:bg-gray-900 dark:text-white dark:border-gray-700 rounded-md p-2 ${
              errors.profile_image ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.profile_image && (
            <p className="text-red-500 text-sm mt-1">{errors.profile_image}</p>
          )}
          {formData.profile_image && (
            <div className="mt-2">
              <img
                src={`https://hrmsnew.prepstripe.com/storage/${formData.profile_image}`}
                alt="Profile Preview"
                className="w-32 h-32 object-cover rounded-full border"
              />
            </div>
          )}
        </div>
      </div>

      {/* <hr className="text-gray-400 my-6"/>

      <p>Emergency Contact details</p> */}

      <div className="relative my-6">
        <div className="flex items-center">
          <hr className="flex-grow border-gray-400" />
          <span className="px-3 text-gray-600 font-medium text-sm">
            Emergency Contact Details
          </span>
          <hr className="flex-grow border-gray-400" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 font-poppins">
        {/* Contact Name Field */}
        <div>
          <label htmlFor="contact_name" className="block dark:text-white text-sm font-medium text-gray-700">
            Contact Name 
          </label>
          <input
            type="text"
            id="contact_name"
            name="contact_name"
            value={formData.contact_name}
            // readOnly
            onChange={handleChange}
            className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
              errors.contact_name ? "border-red-500" : "border-gray-300"
            }`}
            maxLength={50}
            pattern="[A-Za-z\s]+"
            title="Only letters and spaces allowed"
            // disabled
            // required
            // required
          />
          {errors.contact_name && (
            <p className="text-red-500 text-sm mt-1">{errors.contact_name}</p>
          )}
        </div>

        {/* Relationship Field */}
        <div>
          <label htmlFor="relationship" className="block dark:text-white text-sm font-medium text-gray-700">
            Relationship 
          </label>
          <input
            type="text"
            id="relationship"
            name="relationship"
            value={formData.relationship}
            onChange={handleChange}
            // readOnly
            // disabled
            className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
              errors.relationship ? "border-red-500" : "border-gray-300"
            }`}
            maxLength={30}
            // required
            title="Only letters and spaces allowed"
          />
          {errors.relationship && (
            <p className="text-red-500 text-sm mt-1">{errors.relationship}</p>
          )}
        </div>

        {/* Contact Phone Field */}
        <div>
          <label htmlFor="contact_phone" className="block dark:text-white text-sm font-medium text-gray-700">
            Contact Number
          </label>
          <input
            type="tel"
            id="contact_phone"
            name="contact_phone"
            value={formData.contact_phone}
            // readOnly
            // disabled
            onChange={handleChange}
            className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
              errors.contact_phone ? "border-red-500" : "border-gray-300"
            }`}
            maxLength={10}
            // pattern="[0-9]{10}"
            // required
          />
          {errors.contact_phone && (
            <p className="text-red-500 text-sm mt-1">{errors.contact_phone}</p>
          )}
        </div>

        {/* Contact Email Field */}
        <div>
            <label htmlFor="contact_email" className="block dark:text-white text-sm font-medium text-gray-700">
                Contact Email 
            </label>
            <input
                type="email"
                id="contact_email"
                name="contact_email"
                // disabled
                value={formData.contact_email}
                // readOnly
                onChange={handleChange}
                className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
                    errors.contact_email ? "border-red-500" : "border-gray-300"
                }`}
                // required
            />
            {errors.contact_email && <p className="text-red-500 text-sm mt-1">{errors.contact_email}</p>}
        </div>
      </div>

      {/* Submit and Cancel Buttons */}
      <div className="flex justify-between items-center space-x-4 mt-6">
        <button
          type="button"
          onClick={closeModal}
          className="px-4 py-2 dark:bg-gray-900 border dark:hover:bg-gray-700 dark:border-gray-700 bg-gray-500 text-white rounded-md hover:bg-gray-600"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          {initialValues.employee_id ? "Update" : "Add"}
          {loading && (
            <svg
              className="animate-spin h-5 w-5 ml-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
          )}
        </button>
      </div>

    </form>
  );
};

export default EmployeeDetailForm;
